import React, { useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from "recharts";
import { Box, Typography } from "@mui/material";

const defaultColor = "#B6ADC0";
const hoverColor = "#1D013B";

const shortenLabel = (label, maxLength = 10) =>
    label.length > maxLength ? label.slice(0, maxLength) + "…" : label;

const BarChartComponent = ({ chartData }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const data =
        chartData?.ProductCount?.map((item) => ({
            name: item.name,
            Queries: item.count,
            shortName: shortenLabel(item.name),
        })) || [];

    const handleMouseOrTouch = (e) => {
        setTimeout(() => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }, 0);
    };

    if (data.length === 0) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                height={200}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: "Public Sans",
                        color: "#999999",
                        fontWeight: 600,
                    }}
                >
                    No Data Available
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: "100%",
                height: "45vh",
                "& .recharts-wrapper:focus, & .recharts-responsive-container:focus, & .recharts-surface:focus, & svg:focus, & .recharts-wrapper *:focus": {
                    outline: "none !important",
                    boxShadow: "none !important",
                    border: "none !important",
                },
            }}
            onMouseDown={handleMouseOrTouch}
            onTouchStart={handleMouseOrTouch}
        >
            <ResponsiveContainer>
                <BarChart
                    data={data}
                    barGap={5}
                    margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
                >
                    <XAxis
                        dataKey="name"
                        interval={0}
                        tick={{
                            fontSize: 8,
                            fill: "#1D013B",
                            fontFamily: "Public Sans",
                        }}
                    />
                    <YAxis
                        tick={{
                            fontSize: 12,
                            fill: "#808080",
                            fontFamily: "Public Sans",
                        }}
                        tickLine={false}
                    />
                    <Tooltip
                        labelStyle={{
                            fontSize: 14,
                            color: "#1D013B",
                            fontWeight: "bold",
                            fontFamily: "Public Sans",
                        }}
                        cursor={{ fill: "transparent" }}
                    />
                    <Bar
                        dataKey="Queries"
                        barSize={40}
                        radius={[8, 8, 0, 0]}
                        onMouseOver={(_, index) => setActiveIndex(index)}
                        onMouseOut={() => setActiveIndex(null)}
                    >
                        {data.map((_, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={index === activeIndex ? hoverColor : defaultColor}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default BarChartComponent;
